import * as React from 'react';
import { Link } from 'react-router-dom';

import { addModifiers } from '../../../shared/helpers';

interface LinkPanel {
  url: string;
  label: any;
}

interface PanelFooterProps {
  firstLink: LinkPanel;
  nextLink: LinkPanel;
}

export const PanelFooter = ({ firstLink, nextLink }: PanelFooterProps) => (
  <div>
    <div className="panel__header__links panel__header__links-footer">
      {firstLink.url && firstLink.label.includes('Prev') && (
        <Link
          className={addModifiers('panel__header__links', firstLink.label.includes('Prev') ? ['back-blue'] : ['back'])}
          to={firstLink.url}
        >
          {firstLink.label.includes('Prev') && <span className="panel__header__links--back--icon" />}
          {firstLink.label}
        </Link>
      )}
      {nextLink.url && nextLink.label.includes('Next') && (
        <Link
          className={addModifiers('panel__header__links', nextLink.label.includes('Next') ? ['next'] : ['next-orange'])}
          to={nextLink.url}
        >
          {nextLink.label}
          {nextLink.label.includes('Next') && <span className="panel__header__links--next--icon" />}
        </Link>
      )}
    </div>
  </div>
);
